import React from 'react'
import commonStyles from '../../AddPayerCommonStyles.styles'
import Button from '../../../../../components/button/Button'
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import BasicCard from '../../../../../components/card/basiccard/BasicCard'
import Heading from '../../../../../components/heading/Heading'
import { HEADING } from '../../../../../components/heading/constants/constants'
import Icons from '../../../../../components/icons/Icons'
import { PAYER_SECTION_ROUTES } from '../../../../payerssection/constants'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, resetAddPayerSlice, setNewlyAddedPayerData, setPayerCreationSuccessful, setShowAssignToUserTable } from '../../AddPayerSlice'
import { componentKey as authenticationComponentKey } from "../../../../authentication/AuthenticationSlice"
import { QUERY_PARAMS } from '../../../../formssection/constants'
import AssignMembersTable from '../../assignmembers/assignmemberstable/AssignMembersTable'
import useTxNavigate from '../../../../../../libs/txnavigate/TxNavigateHook'

export default function AddPayerSuccess({ setRefreshStep, isEdited = false }) {

    const navigate = useTxNavigate();
    const { basicInfo, newlyAddedPayer, showAssignToUserTable } = useSelector(state => state[componentKey]);
    const { signedInUser } = useSelector(state => state[authenticationComponentKey]);
    const dispatch = useDispatch();

    return (
        <>
            <div style={commonStyles.addPayerSuccessContainer}>

                <BasicCard alignItems="center">
                <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYER_ADDED_SUCCESS} />
                    <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>
                        {
                        `You did it, ${signedInUser?.FirstName || ""}${isEdited ? "'s information has been updated" :"! You just added a new payer!."}`                                              
                        }</Heading>                                       
                    <label style={commonStyles.payerName}>{basicInfo?.PayerFirstName?.value} {basicInfo?.PayerLastName?.value}</label>
                </BasicCard>


                <p style={commonStyles.questionText}>What would you like to do next?</p>

                <div style={commonStyles.buttonsContainer}>
                <Button
                        style={commonStyles.button}
                        onClickCb={() => {
                            navigate(`/${PAYER_SECTION_ROUTES.PAYER}?${QUERY_PARAMS.PAYER_ID}=${newlyAddedPayer?.IdNumber}`);
                            dispatch(setNewlyAddedPayerData({}))
                        }}

                    >                
                        View {basicInfo?.PayerFirstName?.value} {basicInfo?.PayerLastName?.value}'s Profile
                    </Button>


                    {!isEdited && <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => {
                            dispatch(setPayerCreationSuccessful(false));
                            dispatch(resetAddPayerSlice({ signedInUser }));
                            setRefreshStep(0);
                            navigate(`/${PAYER_SECTION_ROUTES.PAYER}/${PAYER_SECTION_ROUTES.ADD}`);
                        }}
                    >
                        Add another payer
                    </Button>}

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => navigate(`/`)}
                    >
                        Go to dashboard
                    </Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => dispatch(setShowAssignToUserTable(true))}
                    >
                        Assign Member Users
                    </Button>
                </div>
            </div>

            {showAssignToUserTable && <AssignMembersTable
                isPopup={true}
                isPopupOpen={showAssignToUserTable}
                payerDetails={newlyAddedPayer}
                onPopupCloseCb={() => dispatch(setShowAssignToUserTable(false))}
            />}
        </>
    )
}